import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { upsertMultipleCompartments } from '../compartmentsSlice'
import { Compartment } from '../models/Compartment'

export const fetchCompartments = createAsyncThunk('compartments/fetch', async (_, { dispatch }) => {
  const compartments = await OLMSApiService.get<Compartment[]>('/compartment/list')

  if (compartments && compartments.length > 0) {
    dispatch(upsertMultipleCompartments(compartments))
  }
})